import { render, staticRenderFns } from "./BuzonPage.vue?vue&type=template&id=ec22e31c&scoped=true&"
import script from "./BuzonPage.vue?vue&type=script&lang=js&"
export * from "./BuzonPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec22e31c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/BuzonPage.vue
// module id = 198
// module chunks = 30